import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 20, color = '#3b82f6', className = '' }) => {
  const dotStyle = {
    backgroundColor: color,
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <div className={`loading-dots ${className}`}>
      <div className="loading-dot" style={dotStyle}></div>
      <div className="loading-dot" style={dotStyle}></div>
      <div className="loading-dot" style={dotStyle}></div>
    </div>
  );
};

export default LoadingSpinner;
